import React from 'react';
import FailureChanged from './FailureChanged';
import SuccessfullyChanged from './SuccessfullyChanged';
import styled from 'styled-components';

const StyledMessage = styled.div`
  padding-top: 20px;
`;

export const FormStatus: React.FunctionComponent<IFormStatus> = ({
  failureMessage,
  successfullyMessage,
}) => {
  if (failureMessage) {
    return (
      <StyledMessage>
        <FailureChanged message={failureMessage} />
      </StyledMessage>
    );
  }
  if (successfullyMessage) {
    return (
      <StyledMessage>
        <SuccessfullyChanged message={successfullyMessage} />
      </StyledMessage>
    );
  }
  return <></>;
};

interface IFormStatus {
  failureMessage?: string;
  successfullyMessage?: string;
}
